<div class="container">
  <div class="row">
    <div class="col-12">

      <shared-error-ui [numerSzkody]="(numerSzkody$|async)!" ></shared-error-ui>

    </div>
  </div>
</div>
